import { render, staticRenderFns } from "./AssignedLotsComponent.vue?vue&type=template&id=a38837d4&lang=pug&"
import script from "./AssignedLotsComponent.vue?vue&type=script&lang=js&"
export * from "./AssignedLotsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports